import { EndpointQueryParameters } from '../../../../../../types/strapi/strapi'
import { CreatedPrintJobsTab } from '../types'

const flexoMachinePrintTypeFilter = {
    name: { $in: ['flexography', 'dummy'] },
}

const digitalMachineBrandFilter = {
    name: { $in: ['Durst', 'GF'] },
}

export default function getCreatedPrintJobsMachinesQueryParams(
    tab: CreatedPrintJobsTab
): EndpointQueryParameters {
    if (tab === 'flexo') {
        return {
            filters: { machine_print_type: flexoMachinePrintTypeFilter },
            pagination: { pageSize: 500, page: 1 },
        }
    }

    return {
        filters: { machine_brand: digitalMachineBrandFilter },
        pagination: { pageSize: 500, page: 1 },
    }
}
